import { createElement } from '../../utils/utils';
export const Span = props => createElement({
  tagName: 'span',
  ...props
});
//# sourceMappingURL=span.js.map